// app/javascript/controllers/lightbox_controller.js
    import { Controller } from "@hotwired/stimulus"

    export default class extends Controller {
      static targets = ["container", "iframe", "backdrop"]
      static values = {
        videoUrl: String
      }

      connect() {
        // Close with escape key
        this.boundKeyHandler = this.handleKeyPress.bind(this)
        document.addEventListener("keydown", this.boundKeyHandler)
      }

      disconnect() {
        document.removeEventListener("keydown", this.boundKeyHandler)
      }

      open(event) {
        event.preventDefault()

        this.iframeTarget.src = this.videoUrlValue

        // Show the lightbox
        this.containerTarget.classList.remove("hidden")
        document.body.classList.add("overflow-hidden")

        // Animate in with Tailwind classes
        setTimeout(() => {
          this.backdropTarget.classList.remove("opacity-0")
          this.containerTarget.classList.remove("opacity-0", "scale-95")
          this.containerTarget.classList.add("opacity-100", "scale-100")
        }, 10)
      }

      close() {
        // Animate out with Tailwind classes
        this.backdropTarget.classList.add("opacity-0")
        this.containerTarget.classList.add("opacity-0", "scale-95")
        this.containerTarget.classList.remove("opacity-100", "scale-100")

        // Complete close after animation
        setTimeout(() => {
          this.containerTarget.classList.add("hidden")
          document.body.classList.remove("overflow-hidden")
          this.iframeTarget.src = "" // Stop video playback
        }, 300)
      }

      // Hides the whole element the lightbox belongs to (the "Hide
      // introduction" button on the intro panels).
      dismiss() {
        this.element.classList.add("hidden")
      }

      handleKeyPress(event) {
        if (event.key === "Escape") {
          this.close()
        }
      }

      clickOutside(event) {
        if (event.target === this.backdropTarget) {
          this.close()
        }
      }
    }